import { format } from "date-fns";
import { th, enUS } from "date-fns/locale";

export function generateApiKey() {
  return (
    "pk_live_" +
    Array.from(
      { length: 32 },
      () =>
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[
          Math.floor(Math.random() * 62)
        ],
    ).join("")
  );
}

export function generateSecretKey() {
  return (
    "sk_live_" +
    Array.from(
      { length: 40 },
      () =>
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[
          Math.floor(Math.random() * 62)
        ],
    ).join("")
  );
}

export function generatePassword() {
  const length = 10;
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const digits = "0123456789";
  const special = "!@#$%^&*()_+";
  const all = upper + lower + digits + special;

  let password = "";
  password += upper.charAt(Math.floor(Math.random() * upper.length));
  password += lower.charAt(Math.floor(Math.random() * lower.length));
  password += digits.charAt(Math.floor(Math.random() * digits.length));
  password += special.charAt(Math.floor(Math.random() * special.length));

  for (let i = password.length; i < length; i++) {
    password += all.charAt(Math.floor(Math.random() * all.length));
  }

  // Shuffle
  return password
    .split("")
    .sort(() => 0.5 - Math.random())
    .join("");
}

export function getTypeLabel(type, t) {
  const normalizedType = String(type || "").toLowerCase();

  if (!normalizedType || normalizedType === "unknown") {
    return t ? t("unknown") : "Unknown";
  }

  const translated = t ? t(normalizedType) : normalizedType;

  return translated === normalizedType
    ? normalizedType.charAt(0).toUpperCase() + normalizedType.slice(1)
    : translated;
}

export function formatDate(date, language = "en") {
  if (!date) return "N/A";

  const dateStr = String(date);
  const parsedDate = new Date(
    dateStr.includes("T") ? dateStr : dateStr.replace(" ", "T") + "Z",
  );

  return format(
    parsedDate,
    language === "th" ? "d MMM, HH:mm" : "MMM d, HH:mm",
    { locale: language === "th" ? th : enUS },
  );
}

export function getCurrencySymbol(currency, defaultCurrency = "THB") {
  const code = String(currency || defaultCurrency).toUpperCase();
  const symbolMap = { PKR: "Rs", IDR: "Rp" };

  return symbolMap[code] || code;
}

export function formatCurrency(value, currencySymbol = "Rs") {
  const n = Number(value ?? 0);

  if (Math.abs(n) >= 1000000) {
    return `${currencySymbol}${new Intl.NumberFormat("en-US", {
      notation: "compact",
      maximumFractionDigits: 2,
    }).format(n)}`;
  }

  return `${currencySymbol}${n.toLocaleString()}`;
}

export function copyToClipboard(e, id, rowKey, setCopiedRowKey) {
  e.stopPropagation();

  navigator.clipboard.writeText(id || "");
  setCopiedRowKey(rowKey);

  setTimeout(() => setCopiedRowKey(null), 2000);
}

const utilities = {
  generateApiKey,
  generateSecretKey,
  generatePassword,
  getTypeLabel,
  formatDate,
  getCurrencySymbol,
  formatCurrency,
  copyToClipboard,
};

export default utilities;
